export default __webpack_public_path__ + "static/media/basket.7d2fe81b.svg";